import {reaction} from 'mobx';
import Websocket from 'modules/Websocket';
import {listenMaintenance} from 'modules/WsSubscription';
import {configStore} from 'app/store/global';
import {isAdmin} from 'app/utils/IsAdmin';

const RELOAD_MAX_DELAY_MS = 5000;

export class MaintenanceModeService {
    static isActive(): boolean {
        return configStore.MAINTENANCE && !isAdmin();
    }

    static connect(): void {
        const token = (window as Window & {USER_UI_DATA?: {token?: string}}).USER_UI_DATA?.token;

        if (!token) {
            return;
        }

        Websocket.init(configStore.WEBSOCKET_URL, token, '/user/ws_token');
        listenMaintenance();
    }

    static watch(onEnabled: () => void): void {
        reaction(MaintenanceModeService.isActive, active => {
            if (active) {
                onEnabled();

                return;
            }

            MaintenanceModeService.reload();
        });
    }

    private static reload(): void {
        window.setTimeout(() => window.location.reload(), Math.random() * RELOAD_MAX_DELAY_MS);
    }
}
